<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <!-- <div id="alertMessage">
            <base-alert type="default" dismissible>
                <span class="alert-inner--text"><strong>Default!</strong> This is a default alert—check it out!</span>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </base-alert>
            </div> -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <base-dropdown v-if="activeModules.length > 0">
                               <base-button slot="title" type="danger" class="dropdown-toggle">
                                 POS Documents - {{_.startCase(currentProfile)}}
                               </base-button> 
                               <a v-for="profile in activeModules" :key="profile.id" @click.prevent="changeFilter(_.pluralize(_.snakeCase(profile.name)))" class="dropdown-item" href="#">{{profile.name}}</a>
                            </base-dropdown>
                            <base-dropdown v-else>
                               <base-button slot="title" type="danger" class="dropdown-toggle">
                                 POS Documents
                               </base-button> 
                               <a class="dropdown-item" disabled>No active module/s under this feature</a>
                            </base-dropdown>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                              <div class="card-body">
                                    <div class="filter-bar ui basic segment grid">
                                        <!-- <div class="ui form">
                                            <div class="inline field">
                                                <h6 class="heading-small text-muted mb-4">Search</h6>
                                                <div class="input-group mb-3">
                                                    <input v-if="searchFilter == 'trans_id'" v-model="filterText.trans_id" type="text" class="form-control" placeholder="Search by trans ID" @keyup.enter="doFilter" style="width: 90%">
                                                    <a-date-picker v-else-if="searchFilter == 'business_date'" v-model="filterText.business_date" :format="dateFormat" size="large" placeholder="Search by business date" style="width: 90%" @change="doFilter"/>
                                                    <a-select v-else-if="searchFilter == 'terminal_id'" size="large" v-model="filterText.terminal_id" showSearch placeholder="Search by terminal" @change="doFilter" optionFilterProp="children" style="width: 90%" :filterOption="filterOption">
                                                        <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                    <a-select v-else-if="searchFilter == 'site_id'" size="large" v-model="filterText.site_id" showSearch placeholder="Search by site" @change="doFilter" optionFilterProp="children" style="width: 90%" :filterOption="filterOption">
                                                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                    <div class="input-group-append" style="width: 10%">
                                                        <base-dropdown v-model="searchFilter" >
                                                            <base-button slot="title" type="secondary" class="btn-outline-primary dropdown-toggle dropdown-toggle-split" style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"/>
                                                            <a class="dropdown-item" @click.prevent="changeSearchFilter('terminal_id')">Terminal</a>
                                                            <a class="dropdown-item" @click.prevent="changeSearchFilter('site_id')">Site</a>
                                                            <a class="dropdown-item" @click.prevent="changeSearchFilter('trans_id')">Trans ID</a>
                                                            <a class="dropdown-item" @click.prevent="changeSearchFilter('business_date')">Business Date</a>
                                                        </base-dropdown>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="row">
                                            <div class="col-md-12">
                                                <base-input label="Business Date"><br>
                                                    <a-range-picker v-model="filterText.business_date" format="MM/DD/YYYY" :placeholder="['Start Date', 'End Date']" style="width:100%" @change="doFilter" />
                                                </base-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <base-input label="Site"><br>
                                                    <a-select v-model="filterText.site_id" showSearch placeholder="Search by site" @change="filterTerminal" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <base-input label="Terminal"><br>
                                                    <a-select v-model="filterText.terminal_id" showSearch placeholder="Search by terminal" @change="doFilter" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                        <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <base-input label="Trans ID"><br>
                                                    <input v-model="filterText.trans_id" type="text" class="form-control" placeholder="Search trans ID" @change="doFilter">
                                                </base-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <base-input label="Customer"><br>
                                                    <input v-model="filterText.customer_name" type="text" class="form-control" placeholder="Search customer" @change="doFilter">
                                                </base-input>
                                            </div>
                                        </div>

                                        <div v-if="currentProfile == 'pos_sales'" class="row">
                                            <div class="col-md-12">
                                                <base-input label="Status">
                                                    <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
                                                        All
                                                    </base-radio>
                                                    <base-radio name="1" class="mb-3" v-model="filterStatus" value="1">
                                                        Posted
                                                    </base-radio>
                                                    <base-radio name="2" class="mb-3" v-model="filterStatus" value="2">
                                                        Suspended
                                                    </base-radio>
                                                    <base-radio name="3" class="mb-3" v-model="filterStatus" value="3">
                                                        Aborted
                                                    </base-radio>
                                                    <base-radio name="4" class="mb-3" v-model="filterStatus" value="4">
                                                        Voided
                                                    </base-radio>
                                                </base-input>
                                            </div>
                                        </div>
                                        <div v-else-if="currentProfile == 'pos_reservations'" class="row">
                                            <div class="col-md-12">
                                                <base-input label="Status">
                                                    <base-radio name="0" class="mb-3" v-model="reservationStatus" value="O">
                                                        All
                                                    </base-radio>
                                                    <base-radio name="1" class="mb-3" v-model="reservationStatus" value="1">
                                                        Unfulfilled
                                                    </base-radio>
                                                    <base-radio name="2" class="mb-3" v-model="reservationStatus" value="2">
                                                        Fulfilled
                                                    </base-radio>
                                                </base-input>
                                            </div>
                                        </div>
                                        <div v-else class="row">
                                            <div class="col-md-12">
                                                <base-input label="Status">
                                                    <base-radio name="0" class="mb-3" v-model="returnStatus" value="O">
                                                        All
                                                    </base-radio>
                                                    <base-radio name="1" class="mb-3" v-model="returnStatus" value="1">
                                                        Voided
                                                    </base-radio>
                                                </base-input>
                                            </div>
                                        </div>
                                    </div>
                              </div>
                            </div>

                            <div class="col-md-9">
                                <div id="profileDiv" class="card-body">
                                    <profiles-table :key="formKey"></profiles-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
  import HTTPRequest from '../../controllers/httpRequest.js'
  import secureStorage from '../../controllers/secureStorage.js'
  import ProfilesTable from '../Tables/PosDocumentTable.vue' 
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment';

  var component_x;

  export default {
      data: function(){
          return {
              formKey: 0,
              activeModules: [],
              filterSettings: {},
              filterText: {
                terminal_id: 0,
                site_id: 0,
                business_date: [moment().subtract(2,'years'), moment().endOf('day')],
                trans_id: '',
                customer_name: '',
                filterStatus: '0',
                returnStatus: '0',
                reservationStatus: '0',
              },
            //   searchFilter: "terminal_id",
              filterStatus: '0',
              returnStatus: '0',
              reservationStatus: '0',
              dateFormat: "MM/DD/YYYY",
              terminalOptions: [],
              siteOptions: []
          }
      },
      mounted: async function() {
            component_x = this;

            var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?name=POS Documents', null, null)
            var siteId = secureStorage.getItem("defaultSiteId")
            let userId = secureStorage.getItem("userId")

            component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
            component_x.setCurrentProfile('pos_sales');
            if( component_x.activeModules.length > 0 ){
                var profile = _.snakeCase(component_x.activeModules[0].name)
                component_x.changeFilter(_.pluralize(profile));
            } else {
                component_x.changeFilter(null);
            } 
            component_x.formKey++

            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.siteOptions.push({id: 0, name: ' All Sites'})
            component_x.sort(component_x.siteOptions);
            component_x.filterText.site_id = siteId

            let response = await HTTPRequest.getRequest(this.endPoint + "user_settings?module_name=pos_document_filter&user_id=" + userId ,null)
            let userSettings = {}
            let terminals;
            if(response.data[0] != undefined) {
                userSettings = JSON.parse(response.data[0].settings_json)
                
                let date_array = null
                if (userSettings.business_date != null && userSettings.business_date.length != 0){
                    date_array = [moment(userSettings.business_date[0]).format('YYYY-MM-DD'), moment(userSettings.business_date[1]).format('YYYY-MM-DD')]
                }

                Object.assign(this.filterText, {
                    terminal_id: userSettings.terminal_id,
                    site_id: userSettings.site_id,
                    business_date: date_array,
                    trans_id: userSettings.trans_id,
                    customer_name: userSettings.customer_name,
                    filterStatus: userSettings.filterStatus
                })

                this.filterStatus = userSettings.filterStatus
                terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + component_x.filterText.site_id, null);
                
                let add_business_date = ""
                if (this.filterText.business_date != null && this.filterText.business_date.length != 0){
                    add_business_date = "&from_date=" + this.moment(this.filterText.business_date[0]).format('YYYY-MM-DD') + "&to_date=" + this.moment(this.filterText.business_date[1]).format('YYYY-MM-DD')
                }

                let add_terminal = ""
                if(this.filterText.terminal_id != 0){
                    add_terminal = "&terminal_id=" + this.filterText.terminal_id
                }

                let add_site =""
                if(this.filterText.site_id != 0){
                    add_site = "&site_id=" + this.filterText.site_id
                }

                let add_status = ""
                console.log(this.currentProfile);
                if(this.currentProfile == 'pos_sales'){
                    add_status = "&is_voided=" + this.filterStatus
                }

                let add_trans_id = ""
                if(this.filterText.trans_id != ""){
                    add_trans_id = "&trans_id=" + this.filterText.trans_id
                }
                this.updateParameters("?customer_name=" + this.filterText.customer_name + add_trans_id + add_status + add_business_date + add_site + add_terminal)
            } else {
                terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
                this.updateParameters("?customer_name=" + this.filterText.customer_name + "&site_id=" + siteId + "&from_date=" + this.filterText.business_date[0].format('YYYY-MM-DD') + "&to_date=" + this.filterText.business_date[1].format('YYYY-MM-DD'))
            }

            component_x.terminalOptions = terminals;
            component_x.terminalOptions.push({id: 0, name: ' All Terminals'})
            component_x.sort(component_x.terminalOptions);
      },
      computed: {
        ...mapState(['currentProfile','currentApiURL', 'endPoint']),
      },
      components:{
          ProfilesTable
      },
      watch: {
        filterStatus: async function() {
            Object.assign(this.filterText, {
                filterStatus: this.filterStatus
            })
            this.doFilter();
        },
        returnStatus: async function() {
            Object.assign(this.filterText, {
                returnStatus: this.returnStatus
            })
            this.doFilter();
        },
        reservationStatus: async function() {
            Object.assign(this.filterText, {
                reservationStatus: this.reservationStatus
            })
            this.doFilter();
        },
      },
      methods:{
        ...mapActions(['updateCurrentProfile', 'updateParameters']),
        moment,
        changeFilter(profile){
            this.updateCurrentProfile(profile)
            this.doFilter()
            this.formKey++
        },
        setCurrentProfile(profile){
            this.updateCurrentProfile(profile)
        },
        filterTerminal: async function(){
            component_x = this
            let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + component_x.filterText.site_id, null);
            component_x.terminalOptions = terminals;
            component_x.terminalOptions.push({id: 0, name: ' All Terminals'})
            component_x.sort(component_x.terminalOptions);

            component_x.filterText.terminal_id = 0

            this.doFilter()
        },
        doFilter: async function(){
            let add_business_date = ""
            if (this.filterText.business_date != null && this.filterText.business_date.length != 0){
                add_business_date = "&from_date=" + this.moment(this.filterText.business_date[0]).format('YYYY-MM-DD') + "&to_date=" + this.moment(this.filterText.business_date[1]).format('YYYY-MM-DD')
            }

            let add_terminal = ""
            if(this.filterText.terminal_id != 0){
                add_terminal = "&terminal_id=" + this.filterText.terminal_id
            }

            let add_site = ""
            if(this.filterText.site_id != 0){
                add_site = "&site_id=" + this.filterText.site_id
            }

            let add_status = ""
            console.log("should be ", this.currentProfile)
            if(this.currentProfile == 'pos_sales'){
                if(this.filterStatus == '0'){
                    add_status = "&is_voided=" + this.filterStatus
                }
                if(this.filterStatus == '1'){
                    add_status = "&status=" + 'P'
                }
                if(this.filterStatus == '2'){
                    add_status = "&status=" + 'S'
                }
                if(this.filterStatus == '3'){
                    add_status = "&status=" + 'A'
                }
                if(this.filterStatus == '4'){
                    add_status = "&is_voided=" + "1"
                }
            } else if(this.currentProfile == 'pos_reservations') {
                add_status = "&reservation_status=" + this.reservationStatus
            } else {
                add_status = "&return_status=" + this.returnStatus
            }

            let add_trans_id = ""
            if(this.filterText.trans_id != ""){
                add_trans_id = "&trans_id=" + this.filterText.trans_id
            }

            let userId = secureStorage.getItem("userId")
            let response = await HTTPRequest.getRequest(this.endPoint + "user_settings?module_name=pos_document_filter&user_id=" + userId ,null)
            if (response.data.length == 0) {
              var createParams = {
                user_setting: {
                  module_name: "pos_document_filter",
                  user_id: userId,
                  settings_json: JSON.stringify(this.filterText)
                }
              }
              await HTTPRequest.postRequest(this.endPoint + "user_settings", null, createParams)
            } else {
              var updateParams = {
                user_setting: {
                  module_name: "pos_document_filter",
                  user_id: userId,
                  settings_json: JSON.stringify(this.filterText)
                }
              }
              await HTTPRequest.putRequest(this.endPoint + "user_settings/" + response.data[0].id, null, updateParams)
            }

            this.updateParameters("?customer_name=" + this.filterText.customer_name + add_trans_id + add_status + add_business_date + add_site + add_terminal)
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        sort(data){
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
      }
  };
</script>

<style>

</style>
